import MergeTypeIcon from "@mui/icons-material/MergeType";
import SplitscreenIcon from "@mui/icons-material/Splitscreen";

const EraserIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width={18}
    height={18}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" />
    <path d="M22 21H7" />
    <path d="m5 11 9 9" />
  </svg>
);

interface AiMappingMeasuredAreaToolsProps {
  mergeDisabled: boolean;
  mergeTitle: string;
  mergeActive: boolean;
  splitDisabled: boolean;
  splitTitle: string;
  splitActive: boolean;
  removeDisabled: boolean;
  removeTitle: string;
  removeActive: boolean;
  onMerge: () => void;
  onSplit: () => void;
  onRemove: () => void;
}

export default function AiMappingMeasuredAreaTools({
  mergeDisabled,
  mergeTitle,
  mergeActive,
  splitDisabled,
  splitTitle,
  splitActive,
  removeDisabled,
  removeTitle,
  removeActive,
  onMerge,
  onSplit,
  onRemove,
}: AiMappingMeasuredAreaToolsProps) {
  const buttons = [
    {
      key: "merge",
      icon: <MergeTypeIcon fontSize="small" color="inherit" />,
      title: mergeTitle,
      disabled: mergeDisabled,
      active: mergeActive,
      onClick: onMerge,
      testId: "measured-area-merge",
    },
    {
      key: "split",
      icon: <SplitscreenIcon fontSize="small" color="inherit" />,
      title: splitTitle,
      disabled: splitDisabled,
      active: splitActive,
      onClick: onSplit,
      testId: "measured-area-split",
    },
    {
      key: "remove",
      icon: <EraserIcon />,
      title: removeTitle,
      disabled: removeDisabled,
      active: removeActive,
      onClick: onRemove,
      testId: "measured-area-remove",
    },
  ];

  return (
    <>
      {buttons.filter(Boolean).map((button) => (
        <button
          key={button.key}
          title={button.title}
          aria-label={button.title}
          type="button"
          className={`toolbar-btn ${button.active ? "active" : ""} ${
            button.disabled ? "disabled" : ""
          }`}
          disabled={button.disabled}
          onClick={button.onClick}
          data-testid={button.testId}
        >
          {button.icon}
        </button>
      ))}
    </>
  );
}
